import type { MaybeN } from "@agrigate/ts-utils/lib/types";
import type { ISelfIdentity } from "@agrigate/user-management-api/lib/services/UsersService";
import { atomWithStorage } from "jotai/utils";

// import { getDefaultStore } from "jotai";

export interface AdminSession
    extends Omit<ISelfIdentity, "id" | "versions" | "dob" | "kycDocs"> {
    id?: MaybeN<string>;
    token?: MaybeN<string>;
}

export const sessionAtom = atomWithStorage<AdminSession | null>(
    "ag:user:v2",
    null,
    undefined,
    { getOnInit: true },
);

// -- ONLY FOR DEBUGGING
// window.SET_ROLES = (roles: string[]) => {
//     getDefaultStore().set(sessionAtom, prev => prev ? ({
//         ...prev,
//         roles,
//     }) : prev);
// };
// --
